import { Value } from 'formulascript/interpreter';

import { wrapFunction } from '../utils';

export const ADDROW = (table: Value, array: Value, number?: Value): Value => {
  if (!Array.isArray(table)) {
    throw new Error('ADDROW expects a table as the first argument');
  }

  if (!Array.isArray(array)) {
    throw new Error('ADDROW expects an array as the second argument');
  }

  const copiedTable = structuredClone(table);

  if (number === undefined) {
    return pushRow(copiedTable, array);
  }

  if (typeof number !== 'number') {
    throw new Error('ADDROW expects a number as the third argument');
  }

  return insertRow(copiedTable, array, number);
};

const pushRow = (table: Value[], row: Value[]): Value[] => {
  table.push(row);
  return table;
};

const insertRow = (table: Value[], row: Value[], index: number): Value[] => {
  const maxRows = table.length;

  const clampedIndex = Math.min(Math.max(index, 0), maxRows);

  table.splice(clampedIndex, 0, row);
  return table;
};

export default wrapFunction(ADDROW, {
  name: 'ADDROW',
  nargs: 2,
  types: ['array', 'array', 'number'],
});
